export const hiringManagerJobsConstants = {
  //create job
  CREATE_JOB_HIRING_MANAGER_ACTION_REQUEST:
    "CREATE_JOB_HIRING_MANAGER_ACTION_REQUEST",
  CREATE_JOB_HIRING_MANAGER_ACTION_SUCCESS:
    "CREATE_JOB_HIRING_MANAGER_ACTION_SUCCESS",
  CREATE_JOB_HIRING_MANAGER_ACTION_FAILURE:
    "CREATE_JOB_HIRING_MANAGER_ACTION_FAILURE",

  //delete job
  DELETE_JOB_HIRING_MANAGER_ACTION_REQUEST:
    "DELETE_JOB_HIRING_MANAGER_ACTION_REQUEST",
  DELETE_JOB_HIRING_MANAGER_ACTION_SUCCESS:
    "DELETE_JOB_HIRING_MANAGER_ACTION_SUCCESS",
  DELETE_JOB_HIRING_MANAGER_ACTION_FAILURE:
    "DELETE_JOB_HIRING_MANAGER_ACTION_FAILURE",

  //update job
  UPDATE_JOB_HIRING_MANAGER_ACTION_REQUEST:
    "UPDATE_JOB_HIRING_MANAGER_ACTION_REQUEST",
  UPDATE_JOB_HIRING_MANAGER_ACTION_SUCCESS:
    "UPDATE_JOB_HIRING_MANAGER_ACTION_SUCCESS",
  UPDATE_JOB_HIRING_MANAGER_ACTION_FAILURE:
    "UPDATE_JOB_HIRING_MANAGER_ACTION_FAILURE",

  //get jobs
  GET_JOBS_HIRING_MANAGER_ACTION_REQUEST:
    "GET_JOBS_HIRING_MANAGER_ACTION_REQUEST",
  GET_JOBS_HIRING_MANAGER_ACTION_SUCCESS:
    "GET_JOBS_HIRING_MANAGER_ACTION_SUCCESS",
  GET_JOBS_HIRING_MANAGER_ACTION_FAILURE:
    "GET_JOBS_HIRING_MANAGER_ACTION_FAILURE",

  // get job details
  GET_JOB_DETAILS_HIRING_MANAGER_ACTION_REQUEST:
    "GET_JOB_DETAILS_HIRING_MANAGER_ACTION_REQUEST",
  GET_JOB_DETAILS_HIRING_MANAGER_ACTION_SUCCESS:
    "GET_JOB_DETAILS_HIRING_MANAGER_ACTION_SUCCESS",
  GET_JOB_DETAILS_HIRING_MANAGER_ACTION_FAILURE:
    "GET_JOB_DETAILS_HIRING_MANAGER_ACTION_FAILURE",

  // set job title
  SET_JOB_TITLE_HIRING_MANAGER_ACTION_REQUEST:
    "SET_JOB_TITLE_HIRING_MANAGER_ACTION_REQUEST",
  SET_JOB_TITLE_HIRING_MANAGER_ACTION_SUCCESS:
    "SET_JOB_TITLE_HIRING_MANAGER_ACTION_SUCCESS",
  SET_JOB_TITLE_HIRING_MANAGER_ACTION_FAILURE:
    "SET_JOB_TITLE_HIRING_MANAGER_ACTION_FAILURE",

  GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_REQUEST:
    "GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_REQUEST",
  GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_SUCCESS:
    "GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_SUCCESS",
  GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_FAILURE:
    "GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_FAILURE",

};
